<div class="flex flex-row w-full gap-1 h-full flex-wrap crops-name-box">

  @if (!onlyNames) {
    @for (crop of crops; track $index) {
      <span
        [style.background-color]="crop | fieldCropsColor "
        [style.width.px]="20"
        [style.height.px]="20"
        [style.display]="'inline-block'"
        [style.border-radius.px]="2"
        [style.margin-right.px]="6"
        class="color-block border-1 gap-8"
        [pTooltip]="crop | serverTranslate:'names'"
        tooltipPosition="top">
      </span>
    }
  }
</div>
<div class="text-gray-500 text-sm">

  @if (!onlyColors) {
    <i>
      @for (crop of crops; track $index) {
        {{ crop | serverTranslate:'names' }}@if (crops.length > 2 && $index < crops.length - 1) {,}
      }
    </i>
  }
</div>
